export default {
  label: {
    id: 'confirmation_page_gift_checkbox',
    defaultMessage: 'Is this a gift?',
  },
}
